import { Collapse, IconButton } from '@material-ui/core';
import { FC, useState } from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {
  StyledFlex,
  Title,
  Container,
} from 'containers/AppContainer/Notifications/style';

export interface BinsWrapperProps {
  title: string | undefined;
}

const BinsWrapper: FC<BinsWrapperProps> = ({ children, title }) => {
  const [open, setOpen] = useState(false);
  const onToggle = () => setOpen(prev => !prev);
  return (
    <Container>
      <StyledFlex>
        <Title>{title}</Title>
        <IconButton onClick={onToggle} size="small" data-testid="expand-button">
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </StyledFlex>
      <Collapse in={open}>{children}</Collapse>
    </Container>
  );
};

export default BinsWrapper;
